import React, { useState } from 'react';
import { Button } from '@src/components/ui/button/button';
import ReplyIcon from '@mui/icons-material/Reply';
import { ShareModal } from './share-modal';

export const ShareButton = () => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    return (
        <>
            <Button
                variant='text'
                className='tw-px-0 tw-min-w-min tw-aspect-square tw-rounded-full'
                onClick={handleClick}
            >
                <ReplyIcon weight='fill' className='tw-text-[#0050C4] tw-transform tw-scale-x-[-1] tw-text-[32px]' />
            </Button>
            <ShareModal open={open} onClose={() => setOpen(false)} />
        </>
    );
};
